theme.transformForm = e => {
    const r = Array.from(e.querySelectorAll(".spr-form-label")),
        o = Array.from(e.querySelectorAll(".spr-form-actions .spr-button"));
    e.querySelector(".spr-form-contact")?.classList.add("grid", "gap-5", "md:grid-cols-2"), e.querySelector(".spr-form-review")?.classList.add("grid", "gap-5"), r.forEach((e => {
        e.control && (e.className = "label is-floating", e.control.placeholder = " ", "INPUT" === e.control.tagName ? e.control.className = "input is-floating" : "TEXTAREA" === e.control.tagName && (e.control.className = "textarea is-floating", e.control.rows = 5), e.control.insertAdjacentElement("afterend", e))
    })), o.forEach((e => {
        e.classList.add("button", "button--primary", "button--fixed")
    }))
}, window.SPRCallbacks = {
    onProductLoad: (e, r) => {
        const o = document.querySelector(`#shopify-product-reviews[data-id="${r.id}"]`),
            t = o.closest(".shopify-section--apps");
        if (!t) return;
        const s = t.querySelector("#shopify-reviews-custom-header");
        s && (o.classList.add("custom-spr"), o.prepend(s.content.cloneNode(!0)))
    },
    onReviewsLoad: (e, r) => {
        const o = document.querySelector(`#shopify-product-reviews[data-id="${r.id}"]`);
        0 === o.querySelector(".spr-reviews").childElementCount && (o.querySelector(".spr-form").style.display = "block")
    },
    onFormLoad: (e, r) => {
        theme.transformForm(document.querySelector(`#shopify-product-reviews[data-id="${r.id}"]`))
    },
    onFormSuccess: (e, r) => {
        document.querySelector(`#shopify-product-reviews[data-id="${r.id}"]`).querySelector(".spr-form-message-success").classList.add("alert", "alert--success")
    },
    onFormFailure: (e, r) => {
        const o = document.querySelector(`#shopify-product-reviews[data-id="${r.id}"]`);
        o.querySelector(".spr-form-message-error").classList.add("alert", "alert--error"), theme.transformForm(o)
    }
};